import * as Sentry from '@sentry/react';
import { ScriptixDescendant } from '@utils/types/editors/transcripts/transcript.ts';
import { Editor, Transforms } from 'slate';

export const changeSpeaker = (
  value: string,
  element: ScriptixDescendant,
  editor: Editor
) => {
  try {
    // Use Slate's Transforms API to properly update nodes
    const pathsToUpdate: number[][] = [];

    for (let i = 0; i < editor.children.length; i++) {
      const child = editor.children[i] as ScriptixDescendant;
      if (child.start === element.start && child.stop === element.stop) {
        pathsToUpdate.push([i]);
      }
    }

    // Apply transformations using Slate's API
    Editor.withoutNormalizing(editor, () => {
      pathsToUpdate.forEach(path => {
        Transforms.setNodes(
          editor,
          { speaker: value } as Partial<ScriptixDescendant>,
          { at: path }
        );
      });
    });
  } catch (error) {
    Sentry.addBreadcrumb({
      category: 'editor',
      message: 'changeSpeaker failed',
      level: 'error',
      data: { value, error: String(error) }
    });
  }
};
